/**
 * What the browser shows before the session query has answered, instead of a
 * blank page, and when the API cannot be reached (same as Wynxx Discovery).
 */

import { AlertTriangle, Loader2 } from 'lucide-react';

export function BootScreen({ error = false }: { error?: boolean }) {
  return (
    <div className="boot-screen">
      <div className="card auth-card">
        <div className="card-body">
          <div className="empty" role={error ? 'alert' : 'status'}>
            <div className={`e-icon${error ? ' e-icon-warning' : ''}`}>
              {error ? <AlertTriangle aria-hidden="true" /> : <Loader2 aria-hidden="true" className="spin" />}
            </div>
            <h3>{error ? 'Atlas cannot reach its API' : 'Starting Atlas'}</h3>
            <p>
              {error
                ? 'Check that the backend is running and reachable, then reload.'
                : 'Loading your session.'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
